export default class adminSettings {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/setting/partials/admin-settings.html'),
            controller: AdminSettingsCtrl,
            controllerAs: 'admin'
        }
    }
};

class AdminSettingsCtrl {
    constructor($scope, $state, $filter, User, Account, Events, SweetAlert, Rest, $location) {
        this._scope = $scope;
        this._state = $state;
        this._translator = $filter('translate');

        this.userRepo = User;
        this.accountRepo = Account;
        this.eventHandler = Events;
        this.alerter = SweetAlert;
        this.rest = Rest.rest;
        this.location = $location;

        this.account = null;
        this.loadingUsers = true;
        this.showUserOverlay = false;

        this.userRepo.all().then((users) => {
            this.loadingUsers = false;
            this.users = users.data;
        });

        this.accountRepo.me().then((response) => {
            this.account = response.data;
        });

        this._scope.$on('setting:newUser', () => {
            this.userRepo.all().then((users) => {
                this.users = users.data;
            });
        });

        if (this.location.search().action === 'add-user') {
            this.toggleUserOverlay();
        }

    }

    removeUser(user, index) {
        this.alerter.swal({
            title: this._translator('GLOBAL:FLASH:DELETE'),
            text: this._translator('SETTING:FLASH:DELETE_USER_BODY'),
            showCancelButton: true,
            confirmButtonText: this._translator('GLOBAL:YES'),
            cancelButtonText: this._translator('GLOBAL:NO'),
            type: 'warning'
        }, (isConfirm) => {
            if (isConfirm) {
                this.userRepo.remove(user).then(() => {
                    this.users.splice(index, 1);
                    this.eventHandler.flashEvent('notification', this._translator('SETTING:FLASH:USER_DELETED'));
                }, (error) => {
                    if (error.data.code == 19) {
                        this.eventHandler.flashEvent('error', this._translator('SETTING:FLASH:USER_DELETED_FAILED_AUTHENTICATED'));
                        return;
                    }

                    this.eventHandler.flashEvent('error', this._translator('SETTING:FLASH:USER_DELETED_FAILED'));
                });
            }
        });
    };

    toggleUserOverlay() {
        this.showUserOverlay = !this.showUserOverlay;
    };

    goToNonTagged() {
        this._state.go('subscriber.folder', {folder: 'non-tagged'});
    };

    goToNewBilling() {
        window.location.href = 'v5/#/app/settings/billing';
    }
}
